import * as joda from "@js-joda/core";

export function isStudentActiveAtLesson(
  lessondate: joda.LocalDate,
  s: {
    enrollment_startedlessonson: joda.LocalDate;
    enrollment_stoppedlessonson: joda.LocalDate | null;
  },
): boolean {
  const enddate = s.enrollment_stoppedlessonson;
  if (lessondate.isBefore(s.enrollment_startedlessonson)) {
    return false;
  }
  if (
    enddate !== null &&
    (lessondate.isEqual(enddate) || lessondate.isAfter(enddate))
  ) {
    return false;
  }
  return true;
}
export const studentIsActiveAtLesson = isStudentActiveAtLesson;
